// Short vibration feedback; silently ignored where unsupported (e.g. iOS Safari).
export const haptic = (pattern = 30) => {
  try { navigator.vibrate?.(pattern); } catch { /* unsupported */ }
};

export const HAPTIC = { add: 25, done: [30, 40, 60], skip: [80, 60, 80], send: [40, 50, 40, 50, 120] };
